import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogTitle,
  IconButton,
  Typography,
} from '@mui/material'
import { useState } from 'react'
import { CloseIcon } from '~components/icons'
import { TSetStatus } from '~components/molecules/animated-alert/animated-alert-provider'
import {
  DocumentPreviewContent,
  isPreviewableExtension,
} from '~components/molecules/document-preview-content'
import { useDocumentDownloads } from '~hooks/use-document-downloads'

const DocumentsPreview = ({
  vesselId,
  documentName,
  tableRowItem,
  setStatusAnimatedAlert,
  versionId,
}: {
  vesselId: string
  documentName: string
  tableRowItem: any
  setStatusAnimatedAlert: TSetStatus
  versionId?: string
}) => {
  const [previewOpen, setPreviewOpen] = useState(false)
  const [previewLink, setPreviewLink] = useState<string | null>(null)
  const { downloadDocuments, getFileLink } = useDocumentDownloads(
    vesselId,
    versionId,
  )

  const documentExtension =
    tableRowItem?.files?.[0]?.filename?.split('.').pop().toLowerCase() ||
    tableRowItem?.fileName?.split('.').pop().toLowerCase() ||
    ''

  const shouldShowActualPreview = isPreviewableExtension(documentExtension)

  const loadPreviewLink = async () => {
    let link
    try {
      if (shouldShowActualPreview) {
        link = await getFileLink(tableRowItem)
      }
      setPreviewOpen(true)
      if (link) {
        setPreviewLink(link)
      }
    } catch {
      setStatusAnimatedAlert('Failed to load document preview', 5000, 'error')
    }
  }

  return (
    <Box sx={{ display: 'block' }}>
      <Typography onClick={() => loadPreviewLink()} variant="link">
        {documentName}
      </Typography>
      <Dialog
        fullScreen={shouldShowActualPreview}
        onClose={() => setPreviewOpen(false)}
        open={previewOpen}
        sx={{ mt: 8, mb: 10, mx: 10 }}
      >
        <IconButton
          aria-label="close"
          onClick={() => setPreviewOpen(false)}
          sx={(theme) => ({
            position: 'absolute',
            right: 8,
            top: 8,
            color: theme.palette.grey[500],
          })}
        >
          <CloseIcon />
        </IconButton>
        <DialogTitle>{documentName || ''}</DialogTitle>
        <DocumentPreviewContent
          url={previewLink || ''}
          fileName={documentName}
          fileExtension={documentExtension}
        />
        <DialogActions>
          <Button variant="contained" onClick={() => setPreviewOpen(false)}>
            Close
          </Button>
          <Button
            variant="contained"
            onClick={async () => {
              downloadDocuments([tableRowItem], setStatusAnimatedAlert)
            }}
          >
            Download
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  )
}

export default DocumentsPreview
